import React from "react";
import { LayerContextProvider, layers, Modal, SlideFromTop } from "@activecollab/components";
import PropTypes from "prop-types";
import { AddTimeRecordContent } from "./AddTimeRecordContent.jsx";

export const AddTimeRecord = ({ open, onClose, date, userId, hidePeoplePicker, source }) => {
  return (
    <LayerContextProvider value={{ zIndex: layers.skyscraper }}>
      <Modal
        open={open}
        onClose={onClose}
      >
        <SlideFromTop in={open}>
          <div className="time_record_modal_wrapper time_record_form_modal_wrapper">
            <AddTimeRecordContent
              onClose={onClose}
              date={date}
              userId={userId}
              hidePeoplePicker={hidePeoplePicker}
              source={source}
            />
          </div>
        </SlideFromTop>
      </Modal>
    </LayerContextProvider>
  );
};

AddTimeRecord.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  date: PropTypes.any,
  userId: PropTypes.number,
  hidePeoplePicker: PropTypes.bool,
  source: PropTypes.string,
};

AddTimeRecord.defaultProps = {
  open: false,
  onClose: () => {},
};
